import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {isBrowser} from "react-device-detect";
import './App.css';

import Header from "./components/Header"
import Footer from "./components/Footer"
import Home from "./components/Home"
import AboutMe from "./components/AboutMe.js"
import Portfolio from "./components/Portfolio.js"
import Resume from "./components/Resume.js"
import Contact from "./components/Contact.js"

/*
Font tag usages:

h1 --> Titles
h2 --> Section Headers
h3 --> Contact Text
h4 --> Download button Text
 */

class App extends Component {

    constructor () {
        super();

        this.state = {
            currentPage: "Home"
        }
        this.handleClick = this.handleClick.bind(this);
        this.needStickyFooter = this.needStickyFooter.bind(this);
        this.checkBrowser = this.checkBrowser.bind(this);
    }

    handleClick (newView) {
        this.setState({ content: newView});
    }

    needStickyFooter = (content) => {
        if (content === "Home") {
            return 0;
        } else if (content === "Portfolio"){
            return 1;
        } else if (content === "Resume"){
            return 0;
        } else if (content === "Contact"){
            return 1;
        }
    }

    checkBrowser = (check) => {
        if (check) {
            return 1;
        } else {
            return 0;
        }
    }

    render() {
        console.log("Current isBrowser status: " + isBrowser)
        let content = [
            <Home isBrowser={this.checkBrowser(isBrowser)}/>,
            <AboutMe />,
        ];

        if (this.state.content === "Home") {
            content = [
                <Home  isBrowser={this.checkBrowser(isBrowser)}/>,
                <AboutMe />,
            ];
        } else if (this.state.content === "Portfolio"){
            content = <Portfolio />;
        } else if (this.state.content === "Resume"){
            content = <Resume />;
        } else if (this.state.content === "Contact"){
            content = <Contact  isBrowser={this.checkBrowser(isBrowser)}/>;
        }

        return (
            <div className="App">
                <Header isBrowser={this.checkBrowser(isBrowser)} handleClick={this.handleClick}/>
                {content}
                <Footer  isBrowser={this.checkBrowser(isBrowser)} needSticky={this.needStickyFooter(this.state.content)} handleClick={this.handleClick}/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js